/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseStepRespVo } from './DeliverFeeWarehouseStepRespVo';
import {
    DeliverFeeWarehouseStepRespVoFromJSON,
    DeliverFeeWarehouseStepRespVoFromJSONTyped,
    DeliverFeeWarehouseStepRespVoToJSON,
    DeliverFeeWarehouseStepRespVoToJSONTyped,
} from './DeliverFeeWarehouseStepRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationInternationalFeeGradeFeeRespVo
 */
export interface DeliveryCalculationInternationalFeeGradeFeeRespVo {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof DeliveryCalculationInternationalFeeGradeFeeRespVo
     */
    gradeId?: number;
    /**
     * 明细渲染模式：STEP 步长规则
     * @type {string}
     * @memberof DeliveryCalculationInternationalFeeGradeFeeRespVo
     */
    ruleMode?: string;
    /**
     * 
     * @type {DeliverFeeWarehouseStepRespVo}
     * @memberof DeliveryCalculationInternationalFeeGradeFeeRespVo
     */
    stepRule?: DeliverFeeWarehouseStepRespVo;
}

/**
 * Check if a given object implements the DeliveryCalculationInternationalFeeGradeFeeRespVo interface.
 */
export function instanceOfDeliveryCalculationInternationalFeeGradeFeeRespVo(value: object): value is DeliveryCalculationInternationalFeeGradeFeeRespVo {
    return true;
}

export function DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSON(json: any): DeliveryCalculationInternationalFeeGradeFeeRespVo {
    return DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationInternationalFeeGradeFeeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'ruleMode': json['ruleMode'] == null ? undefined : json['ruleMode'],
        'stepRule': json['stepRule'] == null ? undefined : DeliverFeeWarehouseStepRespVoFromJSON(json['stepRule']),
    };
}

export function DeliveryCalculationInternationalFeeGradeFeeRespVoToJSON(json: any): DeliveryCalculationInternationalFeeGradeFeeRespVo {
    return DeliveryCalculationInternationalFeeGradeFeeRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationInternationalFeeGradeFeeRespVoToJSONTyped(value?: DeliveryCalculationInternationalFeeGradeFeeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'ruleMode': value['ruleMode'],
        'stepRule': DeliverFeeWarehouseStepRespVoToJSON(value['stepRule']),
    };
}

